import { render, staticRenderFns } from "./Pergunta.vue?vue&type=template&id=d74909b8&scoped=true"
import script from "./Pergunta.vue?vue&type=script&lang=ts"
export * from "./Pergunta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74909b8",
  null
  
)

export default component.exports